import Slider from "@mui/material/Slider";

const SFSlider = (props) => {
  return <Slider {...props} />;
};

export default SFSlider;